import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fd35b1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile-header" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#FFF",
    d: "M0 16.576c0-2.721 3.686-3.399 8-3.399 4.338 0 8 .7 8 3.423S12.314 20 8 20c-4.338 0-8-.7-8-3.424zM2.706 5.295A5.292 5.292 0 0 1 7.998.001a5.293 5.293 0 1 1 .004 10.585H8a5.274 5.274 0 0 1-5.294-5.253v-.038z"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#FFF",
    d: "M0 2V0h28v2H0zm19 7H0V7h19v2zm-5 7H0v-2h14v2z"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo = _resolveComponent("logo")!
  const _component_header_button = _resolveComponent("header-button")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_logo, { width: "116" })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_header_button, {
        to: { name: _ctx.user ? 'Profile' : 'Auth' }
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_header_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open')))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ])
  ]))
}